import clsx from "clsx";

import type { PartialBy } from "@/utils/types";

import type { TypographyProps } from "@/ui/atoms/Typography";
import Typography from "@/ui/atoms/Typography";
import Box from "@/ui/atoms/Box";
import { Icon } from "@proda-ai/ui-kit";
export type ErrorMessageProps = PartialBy<TypographyProps, "variant"> & {
    title?: string;
    body?: React.ReactNode;
};

const testId = "ErrorMessage";
const ErrorMessage = (props: ErrorMessageProps) => {
    const { sx, children, className, title, ...otherProps } = props;

    return (
        <Box
            data-testid={testId}
            className={clsx([testId, className])}
            sx={{
                ...sx,
                backgroundColor: "var(--proda-red-20)",
                border: "1px solid var(--proda-red)",
                borderRadius: "4px",
                padding: "16px",
                textAlign: "center",
                lineHeight: "1",
                display: "flex",
                flexDirection: "column",
                maxWidth: "100%",
                width: "max-content",
                gap: "4px",
            }}
            {...otherProps}
        >
            {title !== undefined && (
                <Box
                    display="flex"
                    alignItems="center"
                    gap="8px"
                    sx={{
                        marginBottom: "10px",
                        alignItems: "center",
                    }}
                >
                    <Icon
                        color="var(--proda-red-120)"
                        icon="circle-exclamation"
                    />
                    <Typography variant="h4">{title}</Typography>
                </Box>
            )}
            {children}
        </Box>
    );
};

export default ErrorMessage;
